Apt.fn.extend('maps', {}, {
	/**
	 * Load listing data
	 */
	loadListings() {
		const scope = this;

		if (
			! scope.map ||
			scope.loading ||
			scope.conf.single ||
			scope.conf.showPoints ||
			scope.map.getZoom() < scope.break
		) {
			return;
		}

		if (! scope.subterritoryReady) {
			scope.initSubterritories();

			return;
		}

		scope.setState(false, true);

		scope.$public.ready(() => {
			if (scope.map.getZoom() < scope.break) {
				scope.setState(true);

				return;
			}

			scope.findListings();
		});
	},

	/**
	 * Query visible layer for listings
	 */
	findListings() {
		const scope = this;
		const layer = scope.layers.subterritories;
		const ids = scope.$public.getFeatures({
			layers: ['subterritories']
		})
			.map(el => el.id)
			.filter(id => ! layer.loaded.includes(id));

		if (! ids.length) {
			scope.setState(true);

			return;
		}

		layer.loaded = [
			...layer.loaded,
			...ids
		];

		scope.fetchListings(ids);
	},

	/**
	 * Fetch listing data
	 *
	 * @param {Array} ids
	 */
	fetchListings(ids) {
		const scope = this;
		const filters = LS.filters.get();
		const fn = () => {
			scope.setState(true);
		};

		scope.stripFilters(filters);

		filters.subterritory_id = ids;

		if ((LS.user.get('hidden') || []).length) {
			filters.user = LS.user.get('id');
		}

		LS.api.get('listings/points', {
			flash: false,
			namespace: 'map',
			data: filters,
			success: data => {
				if (! data.results) {
					fn();

					return;
				}

				scope.addMarkers(data.results, fn);
			},
			error: fn
		});
	}
});